import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  curve: null,
  oversample: 'none'
};
export var createWaveShaperNodeConstructor = function createWaveShaperNodeConstructor(audioNodeConstructor, createInvalidStateError, createNativeWaveShaperNode, createWaveShaperNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(WaveShaperNode, _audioNodeConstructor);

    var _super = _createSuper(WaveShaperNode);

    function WaveShaperNode(context, options) {
      var _this;

      _classCallCheck(this, WaveShaperNode);

      var nativeContext = getNativeContext(context);

      var mergedOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

      var nativeWaveShaperNode = createNativeWaveShaperNode(nativeContext, mergedOptions);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var waveShaperNodeRenderer = isOffline ? createWaveShaperNodeRenderer() : null; // @todo Add a mechanism to only switch a WaveShaperNode to active while it is connected.

      _this = _super.call(this, context, true, nativeWaveShaperNode, waveShaperNodeRenderer);
      _this._isCurveNullified = false;
      _this._nativeWaveShaperNode = nativeWaveShaperNode; // @todo Determine a meaningful tail-time instead of just using one second.

      setAudioNodeTailTime(_assertThisInitialized(_this), 1);
      return _this;
    }

    _createClass(WaveShaperNode, [{
      key: "curve",
      get: function get() {
        if (this._isCurveNullified) {
          return null;
        }

        return this._nativeWaveShaperNode.curve;
      },
      set: function set(value) {
        // Bug #103: Safari does not allow to set the curve to null.
        if (value === null) {
          this._isCurveNullified = true;
          this._nativeWaveShaperNode.curve = new Float32Array([0, 0]);
        } else {
          // Bug #102: Safari does not throw an InvalidStateError when the curve has less than two samples.
          // Bug #104: Chrome, Edge and Opera will throw an InvalidAccessError when the curve has less than two samples.
          if (value.length < 2) {
            throw createInvalidStateError();
          }

          this._isCurveNullified = false;
          this._nativeWaveShaperNode.curve = value;
        }
      }
    }, {
      key: "oversample",
      get: function get() {
        return this._nativeWaveShaperNode.oversample;
      },
      set: function set(value) {
        this._nativeWaveShaperNode.oversample = value;
      }
    }]);

    return WaveShaperNode;
  }(audioNodeConstructor);
};